/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 scorpyos.glb --transform --simplify --ratio 0.5 --draco 
Files: scorpyos.glb [3.12MB] > C:\Users\eviei\Desktop\MODELOSORION\scorpyos\scorpyos-transformed.glb [217.74KB] (93%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function ScorpyosSkin(pos) {
  const { nodes, materials } = useGLTF('/models/scorpyos2-transformed.glb')
  return (
    <group position={[pos[0],pos[1],pos[2]-1.2]}  dispose={null} rotation={[ Math.PI / 2, Math.PI / 2,  Math.PI / 2]}>
      <mesh geometry={nodes['socket_head_cap_screw_iso_ISO_4762_M3_x_6_-_6NA2-70222'].geometry} material={materials.PaletteMaterial002} />
      <mesh geometry={nodes['socket_head_cap_screw_iso_ISO_4762_M3_x_6_-_6NA2-70222_1'].geometry} material={materials.PaletteMaterial001} />
    </group>
  )
}

useGLTF.preload('/models/scorpyos2-transformed.glb')

